<mat-card class="map-container">
  <div #chart class="bar"></div>
</mat-card>
